import { Flex, Text } from "@chakra-ui/react";
import { SharpCornerBox } from "./SharpCornerBox";
import { BoxProps } from "@chakra-ui/react";
import { ShoppingPurchasedThickIcon } from "../../icons/ShoppingPurchasedThickIcon";
import { useTranslation } from "react-i18next";

interface PurchasedContentBadgeProps extends BoxProps {
  text?: string;
  fontSize?: string | number;
}

export function PurchasedContentBadge({
  text,
  fontSize,
  ...props
}: PurchasedContentBadgeProps) {
  const { t } = useTranslation();

  return (
    <SharpCornerBox
      corners={["topLeft", "bottomRight"]}
      background="info.500"
      borderWidth={0}
      opacity={0.95}
      {...props}
    >
      <Flex alignItems="center" gap="8px" py="4px">
        <ShoppingPurchasedThickIcon boxSize="16px" />
        <Text
          fontSize={fontSize || "12px"}
          fontWeight="500"
          color="white"
          whiteSpace="nowrap"
        >
          {text || t("components.cards.purchasedContentBadge.youPurchasedThis")}
        </Text>
      </Flex>
    </SharpCornerBox>
  );
}
